import Tr from 'translations/Translations';
import {ProcedureType} from "./ProcedureType";

export const DemandCategoryType = {
    CLASSIC: "CLASSIC",
    SECTOR: "SECTOR",
    DEFENSE_AND_SECURITY: "DEFENSE_AND_SECURITY",
    EXCLUDED: "EXCLUDED",
}
const _TR_PREFIX = 'demand_category_type_';
export const DemandCategoryTypeLabel = (type) => (Tr(_TR_PREFIX + type));


export const DemandCategoryTypesForProcedure = (procedure) => {
    if (ProcedureType.NATIONAL_SOCIAL_SERVICES === procedure || ProcedureType.EUROPE_SOCIAL_SERVICES === procedure)
        return Object.keys(DemandCategoryType).filter(x => x !== DemandCategoryType.DEFENSE_AND_SECURITY && x !== DemandCategoryType.EXCLUDED);
    else if (ProcedureType.NATIONAL_LOWCOST !== procedure && ProcedureType.NATIONAL_NONPUBLIC_TYPE !== procedure)
        return Object.keys(DemandCategoryType).filter(x => x !== DemandCategoryType.EXCLUDED);
    else
        return Object.keys(DemandCategoryType);
}